<script setup lang="ts">
import Typography from '@components/Typography.vue';
import type { Url } from '@global-types/url.ts';
import IconArrowSquareOut from '@icons/ph_arrow-square-out.svg';
import Icon from '@components/Icon.vue';
import type { Color } from '@global-types/colors.ts';

withDefaults(defineProps<{
  url: Url,
  color?: Color,
}>(), {
  color: 'gray-darker',
});
</script>

<template>
  <a
    :href="url"
    class="selection-item-offer-link"
  >
    <Typography
      variant="small-link"
      :color="color"
    >
      <slot />
    </Typography>

    <Icon
      :svg="IconArrowSquareOut"
      :fill="color"
      height="16"
      width="16"
    />
  </a>
</template>

<style scoped lang="scss">
@use '@styles/variables' as *;
@use '@styles/mixins' as *;

.selection-item-offer-link {
  display: flex;
  align-items: center;
  gap: rem(4);
  text-decoration-color: $colorGrayDarker;
}
</style>
